<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 製品納期調整画面 -->
      <div :style="{ height: basicHeight + 'px' }">
        <t-row v-if="this.dataKbn != '3'">
          <!-- 追加 -->
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_THREE'))"
            class="col_common_left"
          >
            <t-button
              type="primary"
              round
              class="dialogButton_150_40"
              ref="addBtn"
              style="margin-top: 5px"
              @click="addData"
            >
              {{ $t("resource.DUE_DATE_EDIT.BTN_ADD") }}
            </t-button></t-col
          >

          <!-- 削除 -->
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_THREE'))"
            class="col_common_left"
          >
            <t-button
              type="danger"
              round
              class="dialogButton_150_40"
              ref="delBtn"
              style="margin-top: 5px"
              @click="deleteData"
            >
              {{ $t("resource.DUE_DATE_EDIT.BTN_DEL") }}
            </t-button></t-col
          >
        </t-row>
      </div>

      <div style="margin: 10px, 0">
        <t-table
          ref="tableData"
          :data="tableData"
          class="table_common"
          header-cell-class-name="bg-default"
          highlight-current-row
          :height="detailHeight"
          :cell-class-name="tableCellClassName"
          :row-class-name="rowClassName"
          border
          fit
          @selection-change="handleRowClick"
          :key="tableKey"
        >
          <!-- 選択ボックス -->
          <t-table-column
            v-if="dataKbn != '3'"
            prop="selected"
            type="selection"
            class-name="cell_txt_center"
            :selectable="isSelectable"
          />
          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.width"
            :align="column.align"
            :header-align="column.headerAlign"
            :class-name="`${column.class} input_font_small`"
            :show-overflow-tooltip="column.overflowTooltip"
          >
            <template slot-scope="scope">
              <t-input-number
                v-if="editCellData(scope.row, column) == 'inputNumber'"
                class="cell_input_number cell_input_font_small"
                :controls="false"
                :precision="0"
                :min="0"
                :max="99999"
                v-model="scope.row[column.prop]"
                @blur="changeCellData()"
                :ref="`input${scope.row.index}-${column.prop}`"
                @keyup.native.enter="
                  focusNextInput(scope.row.index, column.prop)
                "
                @focus="selectValue($event)"
              ></t-input-number>
              <!-- 納期、受注日、手配日 -->
              <t-date-picker
                v-else-if="cusDeliveryDateInputProc(scope.row, column)"
                v-model="scope.row[column.prop]"
                class="dialogDate cell_input_font_small"
                :clearable="false"
                type="date"
                value-format="yyyy/MM/dd"
                format="yyyy/MM/dd"
                :editable="false"
                :show-icon="false"
                :disabled="dataDisableProc(scope.row, column)"
              >
              </t-date-picker>

              <!-- 課題_納期分割機能の追加 -->
              <t-checkbox
                v-model="scope.row['aodReduceKbnBool']"
                v-else-if="column.prop == 'aodReduceKbnBool'"
                :disabled="true"
              />
              <t-checkbox
                v-model="scope.row['sdCloseStateBool']"
                v-else-if="
                  isKbn == '5' &&
                  column.prop == 'sdCloseState' &&
                  scope.row.index != 0
                "
              />
              <span v-else>
                {{ scope.row[column.prop] }}
              </span>
            </template>
          </t-table-column>

          <t-table-column
            :label="$t('resource.REMARKS_ADD.REMARKS')"
            prop="aodProdRemarksSum"
            :class-name="'cell_txt_center input_font_small'"
            :width="200"
          >
            <!-- :width="getRemarksColumnWidthProc()" -->

            <template slot-scope="scope">
              <div class="bikouDiv">
                <!-- 備考表示 -->
                <span class="bikouText" v-if="scope.row.index == 0">
                  {{ scope.row.aodProdRemarksSum }}
                </span>

                <t-input
                  v-else
                  maxLength="2000"
                  v-model="scope.row.aodProdRemarksSum"
                  :ref="`input${scope.row.index}-aodProdRemarksSum`"
                  @keyup.native.enter="remarksFocusNextInput(scope.row.index)"
                  class="cell_input_font_small"
                  @focus="selectValue($event)"
                />
              </div>
            </template>
          </t-table-column>
        </t-table>
      </div>

      <div :style="{ height: bottomHeight + 'px' }">
        <t-form>
          <t-row>
            <t-col :span="20" class="right">&nbsp;</t-col>
            <t-col :span="4" class="right">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="acceptOrderConfirmBtn"
                @click="acceptOrderConfirm"
                :disabled="confirmButtonFlg"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.sys.sure") }}</t-button
              >
            </t-col>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import { t } from "@/locales";
import {
  searchAodProdInfoByProdNo,
  updAodProdInfo,
} from "@/services/acceptOrder";

import {
  searchReceProdInfoByProdNo,
  updateReceNgInfo,
} from "@/services/jpReceive";
import { searchSendProdInfoByProdNo, updateSendNgInfo } from "@/services/send";

import {
  cmpDetailData,
  formatCurDateToString,
  formatCurrencyToNumber,
  formatDateToString,
  formatRemarksShow,
  formatUndefinedToDate,
  getDialogContentHeightComm,
  getEditColWidthArr,
  getRemarksColumnWidth,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  NUM_ONE,
  NUM_ZERO,
  STR_EMPTY,
  STR_FIVE,
  STR_FOUR,
  STR_ONE,
  STR_THREE,
  STR_TWO,
  STR_ZERO,
} from "@/utils/const";
import { Message, Modal } from "@tellus/component";
export default {
  computed: {},

  data() {
    return {
      //************************区分******************
      // 確定ボタン使用区分
      confirmButtonFlg: true,
      // データ区分(1:納期分割、2：補足、3.クローズ、4：入荷異常、5：納品異常)
      dataKbn: this.isKbn,
      // プロセス区分()
      dataProcKbn: this.procKbn,
      // 見積NO.
      aodQuoteNo: this.aobQuoteNo,
      // 明細NO.
      aodProdNo: this.aodDataProdNo,

      //カバー層のフラップ false:表示しない
      showFlag: false,

      //比較用明細情報
      cmpDetailResult: {},
      //読み込み回数
      numLoads: 1,
      // 基本情報のheight
      basicHeight:
        this.isKbn === STR_THREE
          ? DIALOG_LINE_HEIGHT * 0
          : DIALOG_LINE_HEIGHT * 1,
      // 明細情報のheight
      detailHeight: getDialogContentHeightComm(
        window.innerHeight,
        this.isKbn === STR_THREE
          ? DIALOG_LINE_HEIGHT * 0
          : DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        15
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 4),

      //************************** 表示列**************************
      // 表示列
      columns: [],

      // 受注データ：納期分割、補足、クローズ
      acceptColumns: [
        // 区分
        {
          prop: "aodDataKbn",
          label: t("resource.DUE_DATE_EDIT.PRODUCT_KBN"),
          width: t("widgetSize.tableCommon.width50"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          width: t("widgetSize.tableCommon.width130"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          width: t("widgetSize.tableCommon.width120"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // 得意先納期
        {
          prop: "aodCusDeliveryDate",
          label: t("resource.DUE_DATE_EDIT.CUSTOMER_DELIVERY_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        // 加工_仕入先納期
        {
          prop: "aodMSupDate",
          label: t("resource.DUE_DATE_EDIT.M_SUP_DUE_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        //処理1_仕入先納期
        {
          prop: "aodP1SupDate",
          label: t("resource.DUE_DATE_EDIT.P1_SUP_DUE_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        //処理2_仕入先納期
        {
          prop: "aodP2SupDate",
          label: t("resource.DUE_DATE_EDIT.P2_SUP_DUE_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        //処理3_仕入先納期
        {
          prop: "aodP3SupDate",
          label: t("resource.DUE_DATE_EDIT.P3_SUP_DUE_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        // 受注日
        {
          prop: "aodAcceptDate",
          label: t("resource.DUE_DATE_EDIT.ACCEPT_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        // 手配日
        {
          prop: "aodOrderDate",
          label: t("resource.DUE_DATE_EDIT.ORDER_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        // 受注数
        {
          prop: "aodProdQuantity",
          label: t("resource.DUE_DATE_EDIT.ACCEPT_COUNT"),
          width: t("widgetSize.tableCommon.width60"),
          class: "cell_txt_right",
        },

        // 入荷残
        {
          prop: "aodRcvRemainQty",
          label: t("resource.DUE_DATE_EDIT.RCV_REMAIN_QTY"),
          width: t("widgetSize.tableCommon.width60"),
          class: "cell_txt_right",
        },

        // 変更数
        {
          prop: "aodChangeQty",
          label: t("resource.DUE_DATE_EDIT.CHANGE_COUNT"),
          width: t("widgetSize.tableCommon.width60"),
          class: "cell_txt_right",
        },

        // 補足数
        {
          prop: "aodAddQty",
          label: t("resource.DUE_DATE_EDIT.ADD_COUNT"),
          width: t("widgetSize.tableCommon.width60"),
          class: "cell_txt_right",
        },

        // 削減数
        {
          prop: "aodReduceQty",
          label: t("resource.DUE_DATE_EDIT.CLOSE_COUNT"),
          width: t("widgetSize.tableCommon.width80"),
          class: "cell_txt_right",
        },
        // 削減状態
        {
          prop: "aodReduceKbnBool",
          label: t("resource.DUE_DATE_EDIT.CLOSE_STATE"),
          width: t("widgetSize.tableCommon.width60"),
          class: "cell_txt_center",
        },
      ],

      // 入荷異常データ
      jpRcvErrColumns: [
        // 仕入先
        // {
        //   prop: "jrbSupCodeShow",
        //   label: t("resource.DUE_DATE_EDIT.SUP_CODE"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        // },

        // 品名
        {
          prop: "aodProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          width: t("widgetSize.tableCommon.width130"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          width: t("widgetSize.tableCommon.width120"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 得意先納期
        {
          prop: "aodCusDeliveryDate",
          label: t("resource.DUE_DATE_EDIT.CUSTOMER_DELIVERY_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        // 加工_仕入先納期
        {
          prop: "aodMSupDate",
          label: t("resource.DUE_DATE_EDIT.M_SUP_DUE_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        //処理1_仕入先納期
        {
          prop: "aodP1SupDate",
          label: t("resource.DUE_DATE_EDIT.P1_SUP_DUE_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        //処理2_仕入先納期
        {
          prop: "aodP2SupDate",
          label: t("resource.DUE_DATE_EDIT.P2_SUP_DUE_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        //処理3_仕入先納期
        {
          prop: "aodP3SupDate",
          label: t("resource.DUE_DATE_EDIT.P3_SUP_DUE_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        // 運送数
        {
          prop: "jrdReceQty",
          label: t("resource.DUE_DATE_EDIT.TRANSPORT_NUM"),
          width: 80,
          class: "cell_txt_right",
        },

        // 入荷OK数
        {
          prop: "jrdReceOkQty",
          label: t("resource.DUE_DATE_EDIT.RECE_OK_QUANTITY"),
          width: 80,
          class: "cell_txt_right",
        },

        // 入荷NG数
        {
          prop: "jrdReceNgQty",
          label: t("resource.DUE_DATE_EDIT.RECE_NG_QUANTITY"),
          width: 80,
          class: "cell_txt_right",
        },
        // 異常区分
        {
          prop: "jrdProdExKbnShow",
          label: t("resource.DUE_DATE_EDIT.ABNORMAL_DIFFERENCE"),
          width: 80,
          class: "cell_txt_center",
        },

        // 手配No.
        {
          prop: "jrdOrderNoShow",
          label: t("resource.DUE_DATE_EDIT.ORDER_NO"),
          width: 130,
          class: "cell_txt_left",
        },
      ],

      // 納品異常データ
      sendErrColumns: [
        // 見積No.
        {
          prop: "sdQuoteNo",
          label: t("resource.SEND.ESTIMATED_NO"),
          width: 150,
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 品名
        {
          prop: "aodProdName",
          label: t("resource.SEND.PRODUCT_NAME"),
          width: 150,
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.SEND.PRODUCT_DRAW_NO"),
          width: 150,
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // 得意先納期
        {
          prop: "aodCusDeliveryDate",
          label: t("resource.DUE_DATE_EDIT.CUSTOMER_DELIVERY_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        // 加工_仕入先納期
        {
          prop: "aodMSupDate",
          label: t("resource.DUE_DATE_EDIT.M_SUP_DUE_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        //処理1_仕入先納期
        {
          prop: "aodP1SupDate",
          label: t("resource.DUE_DATE_EDIT.P1_SUP_DUE_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        //処理2_仕入先納期
        {
          prop: "aodP2SupDate",
          label: t("resource.DUE_DATE_EDIT.P2_SUP_DUE_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        //処理3_仕入先納期
        {
          prop: "aodP3SupDate",
          label: t("resource.DUE_DATE_EDIT.P3_SUP_DUE_DATE"),
          width: t("widgetSize.tableCommon.width160"),
          class: "cell_txt_center",
        },

        // 納品数
        {
          prop: "sdSendQty",
          label: t("resource.DUE_DATE_EDIT.SEND_COUNT"),
          width: t("widgetSize.COMMON_WIDTH.SEVENTY"),
          class: "cell_txt_right",
        },

        // 納品NG数
        {
          prop: "sdDeliveryNgQty",
          label: t("resource.DUE_DATE_EDIT.SEND_NG_COUNT"),
          width: t("widgetSize.COMMON_WIDTH.EIGHTY"),
          class: "cell_txt_right",
        },

        // 異常区分
        {
          prop: "sdProdExKbnShow",
          label: t("resource.DUE_DATE_EDIT.ABNORMAL_DIFFERENCE"),
          width: 80,
          class: "cell_txt_center",
        },
        // クローズ状態
        {
          prop: "sdCloseState",
          label: t("resource.ACCEPT_ORDER.CLOSE_STATE"),
          width: t("widgetSize.COMMON_WIDTH.EIGHTY"),
          class: "cell_txt_center",
        },
      ],

      //編集可能な列
      editableColumns: [
        "aodCusDeliveryDate", // 得意先納期
        "aodMSupDate", // 加工_仕入先納期
        "aodP1SupDate", // 処理1_仕入先納期
        "aodP2SupDate", // 処理2_仕入先納期
        "aodP3SupDate", // 処理3_仕入先納期
        "aodAcceptDate", // 受注日
        "aodOrderDate", // 手配日
        "aodChangeQty", // 変更数
        "aodAddQty", // 補足数
        "aodReduceQty", // 削減数
        "aodProdRemarksSum", //備考
        "jrdReceNgQty", // 入荷NG数
        "sdDeliveryNgQty", // 納品NG数
        "sdCloseState", //クローズ
      ],

      //編集可能な日期
      editDateColumn: [
        "aodCusDeliveryDate", // 得意先納期
        "aodMSupDate", // 加工_仕入先納期
        "aodP1SupDate", // 処理1_仕入先納期
        "aodP2SupDate", // 処理2_仕入先納期
        "aodP3SupDate", // 処理3_仕入先納期
        "aodAcceptDate", // 受注日
        "aodOrderDate", // 手配日
      ],

      excludedDataKbn: {
        [STR_ONE]: t("resource.DUE_DATE_EDIT.BTN_PROD_SPLIT"),
        [STR_TWO]: t("resource.DUE_DATE_EDIT.BTN_PROD_ADD"),
        [STR_THREE]: t("resource.DUE_DATE_EDIT.BTN_PROD_CLOSE"),
        [STR_FOUR]: t("resource.DUE_DATE_EDIT.KBN_PROD_RCV_ERR"),
        [STR_FIVE]: t("resource.DUE_DATE_EDIT.KBN_PROD_SEND_ERR"),
      },

      //*********************データ*************************
      // 表示のデータ
      tableData: [],

      // 保存のデータ（受注データ）
      acceptTableInfo: [],

      aodUpdateTime: null,

      tableKey: 0,
    };
  },

  props: {
    isKbn: {
      Type: Object,
    },
    rowData: {
      Type: Object,
    },
    procKbn: {
      Type: Object,
    },
    aobQuoteNo: {
      Type: Object,
    },
    aodDataProdNo: {
      Type: Object,
    },
    jrbReceNo: {
      Type: Object,
    },
    jrdReceDetailNo: {
      Type: Object,
    },
    odOrderNo: {
      Type: Object,
    },
    sbSendNo: {
      Type: Object,
    },
    sdSendDetailNo: {
      Type: Object,
    },
  },

  watch: {
    tableData: {
      handler(newVal) {
        if (this.isKbn == STR_FOUR || this.isKbn == STR_FIVE) {
          this.confirmButtonFlg = false;
        } else {
          this.confirmButtonFlg = newVal.length <= NUM_ONE;
        }
      },
      deep: true, // 深度监听数组变化
    },
  },
  mounted() {
    // データ列の確認
    this.changeColumns();

    // 初期設定
    this.init(this.rowData);

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
    //サイズの変更
    this.handleResize();
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      // 基本情報のheight
      this.basicHeight =
        this.dataKbn === STR_THREE
          ? DIALOG_LINE_HEIGHT * 0
          : DIALOG_LINE_HEIGHT * 1;
      // 明細情報のheight
      this.detailHeight = getDialogContentHeightComm(
        window.innerHeight,
        this.basicHeight,
        DIALOG_LINE_HEIGHT * 1,
        15
      );

      this.colArr = getEditColWidthArr(window.innerWidth, 4);
    },

    // 表示列の確認
    changeColumns() {
      // プロセス区分の仕入先納期リスト
      const excludedProps = [
        "aodMSupDate",
        "aodP1SupDate",
        "aodP2SupDate",
        "aodP3SupDate",
      ];

      const resultProps = excludedProps.filter(
        (_, index) => this.dataProcKbn[index] === "0"
      );

      switch (this.dataKbn) {
        // 納期分割の表示列、「受注日」、「手配日」、「補足数」、「クローズ数」、「クローズ」を表示しない
        case STR_ONE:
          //表示列
          this.columns = this.acceptColumns.filter(
            (col) =>
              !resultProps.includes(col.prop) &&
              col.prop !== "aodAcceptDate" &&
              col.prop !== "aodOrderDate" &&
              col.prop !== "aodAddQty" &&
              col.prop !== "aodReduceQty" &&
              col.prop !== "aodReduceKbnBool"
          );
          break;

        // 製品補足の表示列、「変更数」、「クローズ数」、「クローズ」を表示しない
        case STR_TWO:
          //表示列
          this.columns = this.acceptColumns.filter(
            (col) =>
              !resultProps.includes(col.prop) &&
              col.prop !== "aodChangeQty" &&
              col.prop !== "aodReduceQty" &&
              col.prop !== "aodReduceKbnBool"
          );
          break;

        // 製品クローズの表示列、「変更数」、「補足数」を表示しない
        case STR_THREE:
          //表示列
          this.columns = this.acceptColumns.filter(
            (col) =>
              !resultProps.includes(col.prop) &&
              col.prop !== "aodChangeQty" &&
              col.prop !== "aodAddQty"
          );
          break;

        // 入荷異常製品の表示列
        case STR_FOUR:
          //表示列
          this.columns = this.jpRcvErrColumns.filter(
            (col) => !resultProps.includes(col.prop)
          );
          break;
        // 納品異常製品の表示列
        case STR_FIVE:
          //表示列
          this.columns = this.sendErrColumns.filter(
            (col) => !resultProps.includes(col.prop)
          );
          break;

        default:
          //表示列
          this.columns = this.acceptColumns;
          break;
      }
    },

    //セルデータの保存
    changeCellData() {
      this.aodDataProcess();
    },

    //セルデータの編集
    editCellData(row, column) {
      //入力不可
      if (row.index == 0) {
        return;
      }

      if (!this.editableColumns.includes(column.prop)) {
        return false;
      }

      if (
        column.prop == "aodChangeQty" ||
        column.prop == "aodAddQty" ||
        column.prop == "aodReduceQty" ||
        column.prop == "jrdReceNgQty" ||
        column.prop == "sdDeliveryNgQty"
      ) {
        //異常のreadOnlyが0以外の場合、編集不可
        if (
          (this.isKbn == STR_FOUR &&
            column.prop == "jrdReceNgQty" &&
            row.readOnly != 0) ||
          (this.isKbn == STR_FIVE &&
            column.prop == "sdDeliveryNgQty" &&
            row.readOnly != 0)
        ) {
          return false;
        }
        return "inputNumber";
      } else {
        return false;
      }
    },

    // 初期化
    init(data) {
      //待ちダイアログ表示
      this.showFlag = true;

      //受注情報の初期化
      this.infoInit(data);
    },

    //注文情報の初期化
    infoInit(data) {
      this.setInitValue();
      // this.tableData[0] = data;

      // this.aodDataProcess();
    },

    //初期値の設定
    setInitValue() {
      //待ちダイアログを閉じる
      this.showFlag = false;

      if (
        this.isKbn == STR_ONE ||
        this.isKbn == STR_TWO ||
        this.isKbn == STR_THREE
      ) {
        //製品分割、製品補足、製品クローズ画面：データ検索
        this.searchAodProdInfoByProdNo();
      }
      if (this.isKbn == STR_FOUR) {
        //入荷異常画面：データ検索
        this.searchReceProdInfoByProdNoProc();
      } else if (this.isKbn == STR_FIVE) {
        this.searchSendProdInfoByProdNoProc();
      }
    },

    //入荷異常画面：データ検索
    searchReceProdInfoByProdNoProc() {
      if (!this.showFlag) {
        this.showFlag = true;
      }
      searchReceProdInfoByProdNo({
        obQuoteNo: this.aodQuoteNo,
        odProdNo: this.aodProdNo,
        jrbReceNo: this.jrbReceNo,
        odOrderNo: this.odOrderNo,
        jrdReceDetailNo: this.jrdReceDetailNo,
      })
        .then((res) => {
          this.tableData = res.jpReceDetailInfoList;

          // 備考更新時刻
          if (
            res.jpReceDetailInfoList != null &&
            res.jpReceDetailInfoList.length != 0
          ) {
            this.aodUpdateTime = res.jpReceDetailInfoList[0].aodUpdateTime;
          }
          //this.tableData.push(this.addProc(this.tableData[0]));

          this.aodDataProcess();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },
    //納品異常画面：データ検索
    searchSendProdInfoByProdNoProc() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      searchSendProdInfoByProdNo({
        aobQuoteNo: this.aodQuoteNo,
        aodProdNo: this.aodProdNo,
        sbSendNo: this.sbSendNo,
        sdSendDetailNo: this.sdSendDetailNo,
      })
        .then((res) => {
          res.sendDetailList[0].sdCloseState = "";

          this.tableData = res.sendDetailList;

          // 備考更新時刻
          if (res.sendDetailList != null && res.sendDetailList.length != 0) {
            this.aodUpdateTime = res.sendDetailList[0].aodUpdateTime;
          }
          //this.tableData.push(this.addProc(this.tableData[0]));

          this.aodDataProcess();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //製品分割、製品補足、製品クローズ画面：データ検索
    searchAodProdInfoByProdNo() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      let aodProdParams = {
        aobQuoteNo: this.aodQuoteNo,
        aodProdNo: this.aodProdNo,
      };

      searchAodProdInfoByProdNo(aodProdParams)
        .then((res) => {
          this.tableData = res.acceptOrderDetailInfoList;
          // 共通備考の調整（備考更新時刻）
          this.aodUpdateTime = res.curAcceptUpdDateTime;

          if (this.dataKbn == STR_THREE) {
            var element = this.tableData[0];
            this.tableData.push(this.addProc(element));
          }

          this.aodDataProcess();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //データの処理
    aodDataProcess() {
      // 分割の場合
      if (this.dataKbn === STR_ONE) {
        //得意先納期
        this.tableData[0].aodChangeQty =
          this.tableData[0].aodProdQuantity -
          this.tableData
            .slice(1) // 最初の行をスキップ
            .reduce((total, row) => total + (row.aodChangeQty || 0), 0);
      }
      //入荷異常の場合
      else if (this.dataKbn === STR_FOUR) {
        //最初の行の入荷NG数＝入荷NG数の合計
        this.tableData[0].jrdReceNgQty = this.tableData
          .slice(1) // 最初の行をスキップ
          .reduce((total, row) => total + (row.jrdReceNgQty || 0), 0);
        //入荷OK数=運送数-入荷NG数
        this.tableData[0].jrdReceOkQty =
          this.tableData[0].jrdReceQty - this.tableData[0].jrdReceNgQty;
      }
      //納品異常の場合
      else if (this.dataKbn === STR_FIVE) {
        //最初の行の納品NG数＝納品NG数の合計
        this.tableData[0].sdDeliveryNgQty = this.tableData
          .slice(1) // 最初の行をスキップ
          .reduce((total, row) => total + (row.sdDeliveryNgQty || 0), 0);
      }

      this.tableData.map((item, index) => {
        // //得意先納期
        // item.aodCusDeliveryDate = formatUndefinedToDate(
        //   item.aodCusDeliveryDate
        // );

        //入荷異常と納品異常の場合
        if (this.dataKbn === STR_FOUR || this.dataKbn === STR_FIVE) {
          //得意先納期
          item.aodCusDeliveryDate = formatDateToString(item.aodCusDeliveryDate);

          // 加工_仕入先納期
          item.aodMSupDate = formatDateToString(item.aodMSupDate);
          //処理1_仕入先納期
          item.aodP1SupDate = formatDateToString(item.aodP1SupDate);
          //処理2_仕入先納期
          item.aodP2SupDate = formatDateToString(item.aodP2SupDate);
          //処理3_仕入先納期
          item.aodP3SupDate = formatDateToString(item.aodP3SupDate);
        } else {
          // 得意先納期
          item.aodCusDeliveryDate = formatUndefinedToDate(
            item.aodCusDeliveryDate
          );
          // 加工_仕入先納期
          item.aodMSupDate = item.aodMSupDate
            ? formatUndefinedToDate(item.aodMSupDate)
            : null;
          // 処理1_仕入先納期
          item.aodP1SupDate = item.aodP1SupDate
            ? formatUndefinedToDate(item.aodP1SupDate)
            : null;
          // 処理2_仕入先納期
          item.aodP2SupDate = item.aodP2SupDate
            ? formatUndefinedToDate(item.aodP2SupDate)
            : null;
          // 処理3_仕入先納期
          item.aodP3SupDate = item.aodP3SupDate
            ? formatUndefinedToDate(item.aodP3SupDate)
            : null;
          // 受注日
          item.aodAcceptDate = item.aodAcceptDate
            ? formatUndefinedToDate(item.aodAcceptDate)
            : null;
          // 手配日
          item.aodOrderDate = item.aodOrderDate
            ? formatUndefinedToDate(item.aodOrderDate)
            : null;
        }
        item.aodChangeQty = formatCurrencyToNumber(item.aodChangeQty);
        item.aodAddQty = formatCurrencyToNumber(item.aodAddQty);
        item.aodReduceQty = formatCurrencyToNumber(item.aodReduceQty);
        item.jrdReceNgQty = formatCurrencyToNumber(item.jrdReceNgQty);
        item.sdDeliveryNgQty = formatCurrencyToNumber(item.sdDeliveryNgQty);

        if (index == 0) {
          item.aodDataKbn = "-";
        } else {
          item.aodDataKbn = this.excludedDataKbn[this.dataKbn];
        }
        return item;
      });

      //読み込み回数=1
      if (this.numLoads == 1) {
        // tmpTableData.aobAcceptDate = formatDateToString(
        //   tmpTableData.aobAcceptDate
        // );

        //比較用詳細情報
        this.cmpDetailResult = JSON.parse(
          JSON.stringify(this.extractDetail(this.tableData))
        );
        this.numLoads = this.numLoads + 1;
      }

      this.refreshTable();
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      if (row.index == 0) {
        if (
          column.property == "selected" ||
          column.property == "aodReduceQty" ||
          column.property == "aodOrderDate" ||
          column.property == "aodAddQty" ||
          column.property == "sdCloseState"
        ) {
          return "bg-cell-editable_grey";
        }
        return;
      }

      // 分割データ画面の場合
      // if (this.dataKbn === STR_ONE) {
      if (this.editableColumns.includes(column.property)) {
        if (
          column.property == "aodMSupDate" &&
          this.isEmptyOrNull(row.aodMSupDate)
        ) {
          return;
        } else if (
          column.property == "aodP1SupDate" &&
          this.isEmptyOrNull(row.aodP1SupDate)
        ) {
          return;
        } else if (
          column.property == "aodP2SupDate" &&
          this.isEmptyOrNull(row.aodP2SupDate)
        ) {
          return;
        } else if (
          column.property == "aodP3SupDate" &&
          this.isEmptyOrNull(row.aodP3SupDate)
        ) {
          return;
        } else if (
          column.property == "aodOrderDate" &&
          this.isEmptyOrNull(row.aodOrderDate)
        ) {
          return;
        }

        //異常のreadOnlyが0以外の場合、編集不可
        if (
          (this.isKbn == STR_FOUR &&
            column.property == "jrdReceNgQty" &&
            row.readOnly != 0) ||
          (this.isKbn == STR_FIVE &&
            column.property == "sdDeliveryNgQty" &&
            row.readOnly != 0)
        ) {
          return false;
        }

        //編集可能の背景色
        return "bg-cell-editable";
      } else if (
        column.property == "aodDataKbn" ||
        column.property == "selected" ||
        column.property == "aodReduceKbnBool" ||
        column.property == "jrdProdExKbnShow" ||
        column.property == "sdProdExKbnShow"
      ) {
        return;
      } else {
        return "bg-cell-editable_grey";
      }
    },

    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    // チェックボックス
    isSelectable(row, index) {
      return index !== 0;
    },

    inputCheck() {
      const actionMap = {
        [STR_ONE]: () => this.dataSplitInputCheck(),
        [STR_TWO]: () => this.dataAddInputCheck(),
        [STR_THREE]: () => this.dataCloseInputCheck(),
        [STR_FOUR]: () => this.dataReceNgInputCheck(),
        [STR_FIVE]: () => this.dataSendNgInputCheck(),
      };

      return (actionMap[this.dataKbn] || (() => true))();
    },

    // 変更数の入力チェック
    dataSplitInputCheck() {
      if (this.tableData.length > 1) {
        var firstRow = this.tableData[0];
        var sumDataQty = this.tableData
          .slice(1) // 跳过第一行
          .reduce((total, row) => total + (row.aodChangeQty || 0), 0);

        // 分割の変更数量合計がが入荷残以上の場合
        if (sumDataQty > firstRow.aodRcvRemainQty) {
          Modal.showWarning("", t("message.DATA_SPLIT.CHANGE_QTY_CHECK"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return false;
        }

        for (var index = 0; index < this.tableData.length; index++) {
          const row = this.tableData[index];
          // 分割の変更数量が「0」以下の場合
          if (row.aodChangeQty <= 0) {
            Modal.showWarning(
              "",
              t("message.DATA_SPLIT.CHANGE_QTY_ZERO_CHECK"),
              {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              }
            );
            return false;
          }

          // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
          // 得意先納期　＜　仕入先納期　のチェックの追加
          if (this.checkDueDate(row, "分割製品の")) {
            return false;
          }
          // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
        }
      }
      return true;
    },

    //　補足数の入力チェック
    dataAddInputCheck() {
      if (this.tableData.length > 1) {
        for (let index = 0; index < this.tableData.length; index++) {
          const element = this.tableData[index];
          // 補足数が「0」以下の場合
          if (index > 0 && element.aodAddQty <= 0) {
            Modal.showWarning("", t("message.DATA_SPLIT.ADD_QTY_ZERO_CHECK"), {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            return false;
          }
          // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
          // 得意先納期　＜　仕入先納期　のチェックの追加
          if (this.checkDueDate(element, "補足製品の")) {
            return false;
          }
          // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
        }
      }
      return true;
    },

    //　削減数の入力チェック
    dataCloseInputCheck() {
      if (this.tableData.length > 1) {
        var firstRow = this.tableData[0];
        var reduceRow = this.tableData[1];

        // 分割の削減数が受注数以上の場合
        if (reduceRow.aodReduceQty >= firstRow.aodProdQuantity) {
          Modal.showWarning("", t("message.DATA_SPLIT.REDUCE_QTY_CHECK"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return false;
        }

        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
        // 分割の削減数が入荷残以上の場合、
        //  メッセージが「削減数が入荷残を超えていますが、再確認してください」を表示する
        if (reduceRow.aodReduceQty > firstRow.aodRcvRemainQty) {
          Modal.showWarning("", t("message.DATA_SPLIT.REDUCE_RCV_QTY_CHECK"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return false;
        }
        // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

        // 分割の削減数が「0」以下の場合
        if (reduceRow.aodReduceQty <= 0) {
          Modal.showWarning("", t("message.DATA_SPLIT.REDUCE_QTY_ZERO_CHECK"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return false;
        }

        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
        // 得意先納期　＜　仕入先納期　のチェックの追加
        if (this.checkDueDate(reduceRow, "削減製品の")) {
          return false;
        }
        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
      }
      return true;
    },

    dataReceNgInputCheck() {
      if (this.tableData[0].jrdReceOkQty < 0) {
        Modal.showWarning("", t("message.DATA_SPLIT.RECE_OK_TOTAL_CHECK"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return false;
      }

      for (var index = 1; index < this.tableData.length; index++) {
        const row = this.tableData[index];
        // 入荷異常製品のNG数が「0」以下の場合
        if (this.isEmptyOrNull(row.jrdReceNgQty) || row.jrdReceNgQty <= 0) {
          Modal.showWarning(
            "",
            t("message.DATA_SPLIT.RECE_NG_QTY_ZERO_CHECK"),
            {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            }
          );
          return false;
        }
        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
        // 得意先納期　＜　仕入先納期　のチェックの追加
        if (this.checkDueDate(row, "入荷異常製品の")) {
          return false;
        }
        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
      }
      return true;
    },

    dataSendNgInputCheck() {
      if (this.tableData[0].sdDeliveryNgQty > this.tableData[0].sdSendQty) {
        Modal.showWarning("", t("message.DATA_SPLIT.SEND_NG_TOTAL_CHECK"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return false;
      }

      for (var index = 1; index < this.tableData.length; index++) {
        const row = this.tableData[index];
        // NG数が「0」以下の場合
        if (
          this.isEmptyOrNull(row.sdDeliveryNgQty) ||
          row.sdDeliveryNgQty <= 0
        ) {
          Modal.showWarning(
            "",
            t("message.DATA_SPLIT.SEND_NG_QTY_ZERO_CHECK"),
            {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            }
          );
          return false;
        }
        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
        // 得意先納期　＜　仕入先納期　のチェックの追加
        if (this.checkDueDate(row, "納品異常製品の")) {
          return false;
        }
        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑
      }
      return true;
    },

    // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
    // 得意先納期　＜　仕入先納期　のチェックの追加
    checkDueDate(data, proMsg) {
      if (
        (!this.isEmptyOrNull(data.aodMSupDate) &&
          new Date(data.aodCusDeliveryDate) <= new Date(data.aodMSupDate)) ||
        (!this.isEmptyOrNull(data.aodP1SupDate) &&
          new Date(data.aodCusDeliveryDate) <= new Date(data.aodP1SupDate)) ||
        (!this.isEmptyOrNull(data.aodP2SupDate) &&
          new Date(data.aodCusDeliveryDate) <= new Date(data.aodP2SupDate)) ||
        (!this.isEmptyOrNull(data.aodP3SupDate) &&
          new Date(data.aodCusDeliveryDate) <= new Date(data.aodP3SupDate))
      ) {
        Modal.showWarning(
          "",
          proMsg + t("message.ACCEPT_ORDER.DUE_DATE_COMPARE_CHECK"),
          {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          }
        );
        return true;
      }
      return false;
    },
    // UPD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

    //「確定」ボタン
    acceptOrderConfirm() {
      this.showFlag = true;

      if (this.inputCheck()) {
        //保存用データ処理
        this.aodDataUpdProc();

        if (
          this.isKbn == STR_ONE ||
          this.isKbn == STR_TWO ||
          this.isKbn == STR_THREE
        ) {
          //更新
          updAodProdInfo({
            curAcceptUpdDateTime: this.aodUpdateTime,
            aobQuoteNo: this.aodQuoteNo,
            aodProdNo: this.aodProdNo,
            acceptOrderDetailInfoList: this.acceptTableInfo,
            user: getUserInfo().UserId,
          })
            .then((res) => {
              Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
              this.numLoads = 1;
            })
            .catch((err) => {
              if (err.data != null) {
                Message.showError(
                  t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                );
              } else {
                Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
              }
            })
            .finally(() => {
              this.$emit("ok");
            });
        }
        if (this.isKbn == STR_FOUR) {
          //formatCurDateToString

          if (!this.showFlag) {
            this.showFlag = true;
          }

          updateReceNgInfo({
            jrbReceNo: this.jrbReceNo,
            jpReceDetailInfoList: this.tableData,
            user: getUserInfo().UserId,
          })
            .then((res) => {
              Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));

              this.numLoads = 1;
              //検索処理を行う
              this.searchReceProdInfoByProdNoProc();
            })
            .catch((err) => {
              this.showFlag = false;
              if (err.data != null) {
                // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
                if (err.data.Messages[0].Message == "P06_W006") {
                  Modal.showWarning("", t("message.COMMON_MESSAGE.P06_W006"), {
                    confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
                  });
                  return false;
                } else {
                  // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                }
              } else {
                Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
              }
              //検索処理を行う
              this.searchReceProdInfoByProdNoProc();
            });
        }

        if (this.isKbn == STR_FIVE) {
          if (!this.showFlag) {
            this.showFlag = true;
          }

          updateSendNgInfo({
            sbSendNo: this.sbSendNo,
            sendDetailList: this.tableData.map((item) => ({
              ...item,
              sdCloseState: item.sdCloseStateBool ? "1" : "0",
            })),
            user: getUserInfo().UserId,
          })
            .then((res) => {
              Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));

              this.numLoads = 1;
              //検索処理を行う
              this.searchSendProdInfoByProdNoProc();
            })
            .catch((err) => {
              this.showFlag = false;
              if (err.data != null) {
                Message.showError(
                  t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                );
              } else {
                Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
              }
              //検索処理を行う
              this.searchSendProdInfoByProdNoProc();
            });
        }
      } else {
        this.showFlag = false;
      }

      // フォーカス削除
      this.$refs.acceptOrderConfirmBtn.$el.blur();
    },

    aodDataUpdProc() {
      // 削減データの場合メタデータの変更数量の取得
      var reduceQty =
        this.dataKbn === STR_THREE
          ? this.tableData[0].aodProdQuantity -
            this.tableData
              .slice(1) // 最初の行をスキップ
              .reduce(
                (total, row) => total + (row.aodReduceQty || NUM_ZERO),
                NUM_ZERO
              )
          : NUM_ZERO;

      this.acceptTableInfo = [];

      // メタデータの取得
      var firstData = this.tableData[0];

      for (let index = 0; index < this.tableData.length; index++) {
        const element = this.tableData[index];

        // 受注数量
        var aodChangeQty;

        // 備考の取得
        var aodProdRemarksSum = element.aodProdRemarksSum;
        // 分割の場合、変更数量の取得
        if (this.dataKbn === STR_ONE) {
          aodChangeQty = element.aodChangeQty;
        } else if (this.dataKbn === STR_TWO) {
          // 補足の場合
          // メタデータの場合、保存しない
          if (index == 0) {
            continue;
          }
          // 補足データの場合、受注数量が補足数量
          aodChangeQty = element.aodAddQty;
        } else if (this.dataKbn === STR_THREE) {
          // 削減の場合、
          // メタデータの場合、受注数量が変更数量
          if (index == 0) {
            aodChangeQty = reduceQty;
          } else {
            // 削減データの場合、受注数量が削減数量
            aodChangeQty = element.aodReduceQty;
          }
        }
        var aodTotPurchasePrice =
          (element.aodMUPurchasePrice +
            element.aodP1UPurchasePrice +
            element.aodP2UPurchasePrice +
            element.aodP3UPurchasePrice) *
          aodChangeQty; // 小計仕入金額(JPY)：仕入価格(JPY/个) * 数量
        // 小計売上金額(JPY)：確定売価（JPY/个） * 数量
        var aodTotSalesPrice = element.aodUSetPrice * aodChangeQty;
        this.acceptTableInfo.push({
          aodQuoteNo: element.aodQuoteNo, // 見積No.
          aodProdNo: index === 0 ? element.aodProdNo : NUM_ZERO, // 受注明細No
          aodQuoteChildNo: element.aodQuoteChildNo, // 見積No.子番
          aodProdGroupNo: element.aodProdGroupNo, // 受注製品明細No.
          aodNdProdNo: element.aodNdProdNo, // 採番明細_見積明細No.
          aodQuoteType: element.aodQuoteType, // 受注タイプ 1:製品、2:設計

          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
          aodMisumiKbn: element.aodMisumiKbn, // ミスミ関連区分
          aodMisumiNo: element.aodMisumiNo,
          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

          aodProdName: firstData.aodProdName, // 品名
          aodProdDrawNo: firstData.aodProdDrawNo, // 図番
          aodProdQuantity:
            firstData.aodProdExKbn !== STR_ZERO ? NUM_ZERO : aodChangeQty, // 受注数量
          aodProdUnit: element.aodProdUnit, // 単位
          aodProdShape: element.aodProdShape, // 形状
          aodAcceptDate: this.isEmptyOrNull(element.aodAcceptDate)
            ? null
            : formatCurDateToString(element.aodAcceptDate), // 受注日
          aodUWeight: element.aodUWeight, //  重量(kg/个)
          // 緊急度の追加
          aodUrgent: element.aodUrgent, // 緊急度（0:- 1:必須）
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          aodTreatment: element.aodTreatment, // 処理
          // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          // 納期、注番の変更(見積単位⇒製品単位に変更)
          aodCusDeliveryDate: formatCurDateToString(element.aodCusDeliveryDate), //得意先納期
          aodCusDeliveryDateHistory: element.aodCusDeliveryDateHistory, //得意先納期履歴
          // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
          aodCusDelvCode: element.aodCusDelvCode, //得意先納品先
          // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
          aodCusOrderNo: element.aodCusOrderNo, //注番
          // ADD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
          aodMSupCode: element.aodMSupCode, // 加工_仕入先コード
          aodMSupDate: this.isEmptyOrNull(element.aodMSupDate)
            ? null
            : formatCurDateToString(element.aodMSupDate), // 加工_仕入先納期
          aodMCurType: element.aodMCurType, // 加工_貨幣タイプ
          aodMExr: element.aodMExr, // 加工_レート
          aodMUPrice: element.aodMUPrice, // 加工_加工単価
          aodMUPriceCny: element.aodMUPriceCny, // 加工_加工単価(CNY)
          aodMTransportCost: element.aodMTransportCost, // 加工_運賃(JPY/kg)
          aodMUTransportCost: element.aodMUTransportCost, // 加工_運賃(JPY/个)
          aodMUTransportCostCny: element.aodMUTransportCostCny, // 加工_運賃(CNY/个)
          aodMCommissionRate: element.aodMCommissionRate, // 加工_提成率（%）
          aodMUCommission: element.aodMUCommission, // 加工_提成(JPY/个)
          aodMUPurchasePrice: element.aodMUPurchasePrice, // 加工_仕入価格(JPY/个)

          aodP1SupCode: element.aodP1SupCode, // 処理1_仕入先コード
          aodP1SupDate: this.isEmptyOrNull(element.aodP1SupDate)
            ? null
            : formatCurDateToString(element.aodP1SupDate), // 処理1_仕入先納期
          aodP1CurType: element.aodP1CurType, // 処理1_貨幣タイプ
          aodP1Exr: element.aodP1Exr, // 処理1_レート
          aodP1UPrice: element.aodP1UPrice, // 処理1_加工単価(JPY)
          aodP1TransportCost: element.aodP1TransportCost, // 処理1_運賃(JPY/kg)
          aodP1UTransportCost: element.aodP1UTransportCost, // 処理1_運賃(JPY/个)
          aodP1CommissionRate: element.aodP1CommissionRate, // 処理1_提成率（%）
          aodP1UCommission: element.aodP1UCommission, // 処理1_提成(JPY/个)
          aodP1UPurchasePrice: element.aodP1UPurchasePrice, // 処理1_仕入価格(JPY/个)

          aodP2SupCode: element.aodP2SupCode, // 処理2_仕入先コード
          aodP2SupDate: this.isEmptyOrNull(element.aodP2SupDate)
            ? null
            : formatCurDateToString(element.aodP2SupDate), // 処理2_仕入先納期
          aodP2CurType: element.aodP2CurType, // 処理2_貨幣タイプ
          aodP2Exr: element.aodP2Exr, // 処理2_レート
          aodP2UPrice: element.aodP2UPrice, // 処理2_加工単価(JPY)
          aodP2TransportCost: element.aodP2TransportCost, // 処理2_運賃(JPY/kg)
          aodP2UTransportCost: element.aodP2UTransportCost, // 処理2_運賃(JPY/个)
          aodP2CommissionRate: element.aodP2CommissionRate, // 処理2_提成率（%）
          aodP2UCommission: element.aodP2UCommission, // 処理2_提成(JPY/个)
          aodP2UPurchasePrice: element.aodP2UPurchasePrice, // 処理2_仕入価格(JPY/个)

          aodP3SupCode: element.aodP3SupCode, // 処理3_仕入先コード
          aodP3SupDate: this.isEmptyOrNull(element.aodP3SupDate)
            ? null
            : formatCurDateToString(element.aodP3SupDate), // 処理3_仕入先納期
          aodP3CurType: element.aodP3CurType, // 処理3_貨幣タイプ
          aodP3Exr: element.aodP3Exr, // 処理3_レート
          aodP3UPrice: element.aodP3UPrice, // 処理3_加工単価(JPY)
          aodP3TransportCost: element.aodP3TransportCost, // 処理3_運賃(JPY/kg)
          aodP3UTransportCost: element.aodP3UTransportCost, // 処理3_運賃(JPY/个)
          aodP3CommissionRate: element.aodP3CommissionRate, // 処理3_提成率（%）
          aodP3UCommission: element.aodP3UCommission, // 処理3_提成(JPY/个)
          aodP3UPurchasePrice: element.aodP3UPurchasePrice, // 処理3_仕入価格(JPY/个)

          aodGrossMargin: element.aodGrossMargin, // 粗利率(%)　-99.99～100.00
          aodUSalesPrice: element.aodUSalesPrice, // 売価(JPY/个)：仕入価格(JPY/个) / （1‐粗利率(%)）
          aodUSetPrice: element.aodUSetPrice, // 確定売価(JPY/个)
          aodUGrossProfit: element.aodUGrossProfit, // 粗利(JPY/个)：確定売価（JPY/个）  - 価格(JPY/个)
          aodTotPurchasePrice: aodTotPurchasePrice, // 小計仕入金額(JPY)：仕入価格(JPY/个) * 数量
          aodTotSalesPrice: aodTotSalesPrice, // 小計売上金額(JPY)：売価（JPY/个） * 数量
          aodTotGrossProfit: aodTotSalesPrice - aodTotPurchasePrice, // 小計粗利(JPY)：小計売上（JPY） -  小計原価（JPY）
          aodTotWeight: element.aodUWeight * aodChangeQty, // 小計重量(kg)：重量（kg/个） *  数量
          aodProdExKbn: element.aodProdExKbn, // 製品異常区分
          aodProdReceExKbn: firstData.aodProdReceExKbn, // 製品入荷異常区分
          aodReduceKbn: element.aodReduceKbnBool ? STR_ONE : STR_ZERO, // 削減区分
          aodDiscussStatus: element.aodDiscussStatus, //打合状態

          aodCloseState: element.aodCloseState,
          aodProdExQty:
            firstData.aodProdExKbn !== STR_ZERO ? aodChangeQty : NUM_ZERO, //　異常数
          aodProdSuppQty:
            firstData.aodProdExKbn !== STR_ZERO ||
            firstData.aodProdReceExKbn !== STR_ZERO
              ? aodChangeQty
              : NUM_ZERO, //補足件数
          aodProdCloseQty: firstData.aodProdCloseQty,

          aodExCreateDate: firstData.aodExCreateDate, // 異常発生日
          aodExSendNo: firstData.aodExSendNo, // 異常発生NO.
          aodExSendDetailNo: firstData.aodExSendDetailNo, // 異常発生詳細NO.

          aodProdRemarks: aodProdRemarksSum, // 備考

          aodOrderDate: this.isEmptyOrNull(element.aodOrderDate)
            ? null
            : formatCurDateToString(element.aodOrderDate), // 手配日
        });
      }
    },

    //タブ切り替え
    handleTabClick(tab, event) {},

    // 製品異常
    rowClassName({ row }) {
      if (this.isKbn == STR_FOUR) {
        if (
          !(row.jrdProdExKbn == STR_ZERO && row.jrdProdReceExKbn == STR_ZERO)
        ) {
          return "textColor";
        }
      }
      if (this.isKbn == STR_FIVE) {
        if (!(row.sdProdExKbn == STR_ZERO && row.sdProdReceExKbn == STR_ZERO)) {
          return "textColor";
        }
      }

      if (
        this.isKbn == STR_ONE ||
        this.isKbn == STR_TWO ||
        this.isKbn == STR_THREE
      ) {
        if (row.aodProdExKbn != STR_ZERO && row.aodProdReceExKbn != STR_ZERO) {
          return "textColor";
        }
      }
    },

    // 追加製品
    addData() {
      if (typeof this.$refs.addBtn !== "undefined") {
        // フォーカス削除
        this.$refs.addBtn.$el.blur();
      }

      var element = this.tableData[0];

      const elementNew = this.addProc(element);
      this.tableData.push(elementNew);
      this.aodDataProcess();
    },

    addProc(element) {
      var currentDate = new Date();
      const hasAnyDueDate = !!(
        element.aodMSupDate ||
        element.aodP1SupDate ||
        element.aodP2SupDate ||
        element.aodP3SupDate
      );

      if (
        this.dataKbn === STR_ONE ||
        this.dataKbn === STR_TWO ||
        this.dataKbn === STR_THREE
      ) {
        return {
          ...element,
          aodProdName: STR_EMPTY, // 品名
          aodProdDrawNo: STR_EMPTY, // 図番
          aodProdQuantity: STR_EMPTY, // 受注数
          aodRcvRemainQty: STR_EMPTY, // 入荷残
          aodChangeQty: NUM_ZERO, // 変更数
          aodAddQty: NUM_ZERO, // 補足数
          aodReduceQty: NUM_ZERO, // クローズ数
          aodReduceKbnBool: this.dataKbn === STR_THREE, //削減区分
          aodProdRemarksSum: STR_EMPTY,
          aodAcceptDate: currentDate, // 受注日
          aodOrderDate: hasAnyDueDate ? currentDate : null, // 手配日
          index: this.tableData.length,
        };
      } else if (this.dataKbn === STR_FOUR) {
        return {
          ...element,
          aodProdName: STR_EMPTY, // 品名
          aodProdDrawNo: STR_EMPTY, // 図番
          jrdReceQty: STR_EMPTY, //運送数
          jrdReceOkQty: STR_EMPTY, //入荷OK数
          jrdReceNgQty: 0, //入荷NG数
          jrdOrderNoShow: STR_EMPTY, //手配No.
          jrdProdReceExKbn: STR_ONE, // 入荷異常区分
          odOrderDetailNo: 0,
          aodProdRemarksSum: STR_EMPTY,
          jrdProdExKbnShow: "-",
          index: this.tableData.length,
        };
      } else if (this.dataKbn === STR_FIVE) {
        return {
          ...element,
          aodProdName: STR_EMPTY, // 品名
          aodProdDrawNo: STR_EMPTY, // 図番
          sdSendQty: STR_EMPTY, //納品数
          sdDeliveryNgQty: 0, //納品NG数
          sdQuoteNo: STR_EMPTY, //手配No.
          sdProdExKbn: STR_TWO, // 納品異常区分
          sdProdExKbnShow: "-",
          aodProdNo: 0,
          aodProdRemarksSum: STR_EMPTY,
          index: this.tableData.length,
        };
      }
    },

    // 製品削除
    deleteData() {
      if (!this.showFlag) {
        this.showFlag = true;
      }
      // フォーカス削除
      this.$refs.delBtn.$el.blur();
      // 選択データ
      let data = this.$refs.tableData.selection;

      if (data == null || data.length < 1) {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.DELETE_CONFIRM_MSG"), {
          $type: "prompt",
          confirmButtonText: t("resource.COMMON_CONSTANT.YES"),
          cancelButtonText: t("resource.COMMON_CONSTANT.NO"),
          showCancelButton: true,
        }).then(() => {
          if (Array.isArray(data)) {
            // 使用 filter 方法过滤掉选中的数据
            this.tableData = this.tableData.filter((item) => {
              return !data.some(
                (selectedItem) => selectedItem.index === item.index
              );
            });
          }

          this.aodDataProcess();
        });
      }

      if (this.showFlag) {
        this.showFlag = false;
      }
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      index = index + 1;

      if (index > this.tableData.length - 1) {
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
      } else {
        var i = index;
        for (i; i < this.tableData.length; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
        //下に入力ボックスがない場合は、最初から
        if (i == this.tableData.length) {
          this.focusNextInput(-1, columnProp);
        }
      }
    },

    //Enter処理
    remarksFocusNextInput(index) {
      index = index + 1;

      if (index > this.tableData.length - 1) {
        this.$refs[`input${1}-aodProdRemarksSum`].focus();
      } else {
        this.$refs[`input${index}-aodProdRemarksSum`].focus();
      }
    },

    //フォームで変更される可能性のアイテムの取得
    extractBasic(data) {
      return {
        aobUserCode: data.aobUserCode,
        aobAcceptState: data.aobAcceptState,
        aobAcceptDate: data.aobAcceptDate,
      };
    },
    //テーブルで変更される可能性のある列の取得
    extractDetail(data) {
      return data.map((item, index) => {
        return {
          index: index,
          aodCusDeliveryDate: formatCurDateToString(item.aodCusDeliveryDate),
          aodMSupDate: formatCurDateToString(item.aodMSupDate),
          aodP1SupDate: formatCurDateToString(item.aodP1SupDate),
          aodP2SupDate: formatCurDateToString(item.aodP2SupDate),
          aodP3SupDate: formatCurDateToString(item.aodP3SupDate),
          aodAcceptDate: formatCurDateToString(item.aodAcceptDate),
          aodOrderDate: formatCurDateToString(item.aodOrderDate),
          aodChangeQty: item.aodChangeQty,
          aodAddQty: item.aodAddQty,
          aodReduceQty: item.aodReduceQty,
          jrdReceNgQty: item.jrdReceNgQty,
          sdDeliveryNgQty: item.sdDeliveryNgQty,
          sdCloseState: item.sdCloseStateBool,
          aodProdRemarksSum: item.aodProdRemarksSum?.trim(),
        };
      });
    },

    //ダイアログを閉じる
    onCancel() {
      if (
        !cmpDetailData(
          JSON.parse(JSON.stringify(this.cmpDetailResult)),
          JSON.parse(JSON.stringify(this.extractDetail(this.tableData)))
        )
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    //納期コントロール
    cusDeliveryDateInputProc(row, column) {
      //納期以外の場合、何もしない
      if (this.editDateColumn.includes(column.prop)) {
        if (row.index === NUM_ZERO && column.prop === "aodOrderDate") {
          return false;
        }

        return true;
      }
      return;
    },

    dataDisableProc(row, column) {
      if (row.index == 0) {
        return true;
      }
      if (column.prop == "aodMSupDate" && this.isEmptyOrNull(row.aodMSupDate)) {
        return true;
      } else if (
        column.prop == "aodP1SupDate" &&
        this.isEmptyOrNull(row.aodP1SupDate)
      ) {
        return true;
      } else if (
        column.prop == "aodP2SupDate" &&
        this.isEmptyOrNull(row.aodP2SupDate)
      ) {
        return true;
      } else if (
        column.prop == "aodP3SupDate" &&
        this.isEmptyOrNull(row.aodP3SupDate)
      ) {
        return true;
      } else if (
        column.prop == "aodOrderDate" &&
        this.isEmptyOrNull(row.aodOrderDate)
      ) {
        return true;
      }
      return false;
    },

    // 入力ボックスをクリックの場合、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },

    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.tableData);
    },

    //値がNULLまたはEmptyです
    isEmptyOrNull(item) {
      if (item == undefined || item == null || item == STR_EMPTY) {
        return true;
      } else {
        return false;
      }
    },

    // 选中的行数据
    handleRowClick(row) {
      this.currentCell = row;
    },
    refreshTable() {
      this.tableKey += 1; // key値を更新し、テーブルの再レンダリングをトリガーする
    },
  },
};
</script>
<style scoped>
.editInput {
  width: 90%;
  height: 17px;
  line-height: 0;
}

.el-table__body {
  height: 200px;
}

::v-deep .el-table.table_common .el-table__fixed {
  height: auto !important;
  bottom: 16px;
}
</style>
